<template>
    <div class="ah-solo-page">
        <!-- Token 正常 -->
        <template v-if="tokenStatus === 1">
            <div class="ah-panel padding medium" v-if="!isSetPassFinished">
                <h1 class="page-title">
                    {{ greetingMsg }}
                </h1>
                <el-alert v-if="this.expireTime && !isExpired" :closable="false" center>
                    請在
                    {{ this.expireTime.getFullYear() }} 年 {{ this.expireTime.getMonth() + 1 }} 月 {{ this.expireTime.getDate() }} 日 {{ this.expireTime.getHours() }}:{{
                        this.expireTime.getMinutes()
                    }}
                    前完成設定
                </el-alert>
                <el-alert v-if="isExpired" title="密碼重設已過期" type="error" description="此密碼設定已逾時，請聯絡帳號管理員，或使用忘記密碼再次重設。" :closable="false" show-icon> </el-alert>
                <el-form ref="form" :rules="rules" :model="form" class="ah-form" label-position="top" v-if="!isExpired">
                    <el-form-item prop="company_id" label="公司 ID">
                        <el-input :value="form.cmp" style="font-size: 12pt; font-weight: bold; line-height: 100%" disabled></el-input>
                    </el-form-item>
                    <el-form-item prop="pwd">
                        <template v-slot:label>
                            密碼（密碼長度需8-12個字元，至少包含英文及數字）
                        </template>
                        <el-input v-model="form.pwd" type="password" autocomplete="off" show-password></el-input>
                    </el-form-item>
                    <el-form-item prop="checkPwd" label="再次輸入密碼">
                        <el-input v-model="form.checkPwd" type="password" autocomplete="off" show-password></el-input>
                    </el-form-item>
                </el-form>
                <center style="margin-top: 50px">
                    <el-button @click="login">回登入</el-button>
                    <el-button :loading="isLoading" v-if="!isExpired" type="primary" class="primary-action" @click="submit">送出</el-button>
                </center>
            </div>
            <div class="ah-panel padding medium" v-else>
                <h1 class="page-title">繼續登入</h1>
                <div class="page-description">您的密碼已變更，請重新登入。</div>
                <center style="margin-top: 50px">
                    <el-button type="primary" class="primary-action" round @click="login">登入</el-button>
                </center>
            </div>
        </template>
        <!-- 無此 Token -->
        <template v-if="tokenStatus === 2">
            <!-- 此帳號密碼之前已設定完成 -->
            <div class="ah-panel padding medium" v-if="hasPassword">
                <h1 class="page-title">此帳號已完成密碼設定</h1>
                <center style="margin-top: 50px">
                    <el-button type="primary" @click="login">回登入</el-button>
                </center>
            </div>
            <!-- 錯誤 -->
            <div class="ah-panel padding medium" v-else>
                <h1 class="page-title">設定錯誤</h1>
                <center><p>請與帳號管理員聯繫，重新配發密碼信。</p></center>
                <center style="margin-top: 50px">
                    <el-button type="primary" @click="login">回登入</el-button>
                </center>
            </div>
        </template>
        <!-- Token 已無效（已有新Token） -->
        <template v-if="tokenStatus === 3">
            <div class="ah-panel padding medium">
                <h1 class="page-title">此密碼信已無效</h1>
                <center><p>您的帳號已有新的密碼信，請開啟最新的一封密碼信內的連結。</p></center>
                <center style="margin-top: 50px">
                    <el-button type="primary" @click="login">回登入</el-button>
                </center>
            </div>
        </template>
        <!-- Token 已過期 -->
        <template v-if="tokenStatus === 4">
            <div class="ah-panel padding medium">
                <h1 class="page-title">此密碼信已過期</h1>
                <center v-if="hasPassword">
                    <p>如您還需要重新設定密碼，請點選忘記密碼，重新配發密碼信。</p>
                </center>
                <center v-if="!hasPassword"><p>請聯絡您的帳號管理員，重新配發密碼信。</p></center>
                <center style="margin-top: 50px">
                    <el-button @click="$router.push({ name: 'forgotPassword' })">忘記密碼 </el-button>
                    <el-button type="primary" @click="login">回登入</el-button>
                </center>
            </div>
        </template>
    </div>
</template>
<script>
export default {
    components: {},
    data() {
        const validatePass = (rule, value, callback) => {
            // 包含英文及數字_檢查
            const regExp = /^(?![0-9]*$)(?![a-zA-Z]*$)[a-zA-Z0-9\W]{8,20}$/;
            const isValidate = regExp.test(value);

            if (value === '') {
                callback(new Error('請輸入密碼'));
            } else if (value.length < 8 || value.length > 12 || !isValidate) {
                callback(new Error('密碼長度需8-12個字元，至少包含英文及數字'));
            } else {
                if (this.checkPwd !== '') {
                    this.$refs.form.validateField('checkPwd');
                }
                callback();
            }
        };

        const validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('請再次輸入密碼'));
            } else if (value !== this.form.pwd) {
                callback(new Error('兩次輸入密碼不一致!'));
            } else {
                callback();
            }
        };
        function generateUUID() {
            return 'xxxx-xxxx-4xxx-yxxx-xxxx'.replace(/[xy]/g, (c) => {
                const r = (Math.random() * 16) | 0;
                const v = c === 'x' ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        }
        function getDeviceCode() {
            let code = localStorage.getItem('device_code');
            if (code) {
                return code;
            }
            code = generateUUID();
            localStorage.setItem('device_code', code);
            return code;
        }
        return {
            tokenStatus: null, // 1: token正確, 2: db token null (設定過), 3: token不一致, 4: 過期
            hasPassword: null,
            isLoading: false,
            isSetPassFinished: false,
            expireTime: null,
            currentTime: new Date(),
            form: {
                token: '',
                pwd: '',
                cmp: this.$route.params.company_id,
                checkPwd: '',
                logiN_CODE: getDeviceCode(),
            },
            rules: {
                pwd: [
                    {
                        validator: validatePass,
                        trigger: 'blur',
                    },
                ],
                checkPwd: [
                    {
                        validator: validatePass2,
                        trigger: 'blur',
                    },
                ],
            },
        };
    },
    mounted() {
        // start loading
        const loading = this.$loading({
            lock: true,
            text: '載入中',
            spinner: 'el-icon-loading',
            background: 'rgba(255, 255, 255, 0.7)',
        });

        // decode (base64) token from url
        // const token = this.$route.params.token;
        const token = this.base64UrlDecode(this.$route.params.token);
        const eml = this.base64UrlDecode(this.$route.params.email);

        this.form.token = token;

        // get token status
        this.$api({
            url: '/LoginPage/ValidateResetPasswordToken',
            method: 'post',
            data: {
                token,
                cmp: this.$route.params.company_id,
                eml,
            },
        }).then((resp) => {
            loading.close();
            this.tokenStatus = resp.data.status;
            this.hasPassword = resp.data.hasPassword;
            console.log('token', resp);
        });

        // setTimeout(() => {
        //   loading.close();
        // }, 2000);

        if (this.$route.params.expireTime) {
            this.expireTime = new Date(Number(this.$route.params.expireTime));
            console.log(this.expireTime);
        }
    },
    computed: {
        isExpired() {
            if (this.expireTime) {
                return this.currentTime > this.expireTime;
            }
            return false;
        },
        greetingMsg() {
            if (this.hasPassword === true) {
                return '請重新設定你的密碼';
            }
            if (this.hasPassword === false) {
                return '歡迎初次登入，請設定你的密碼';
            }
            return '';
        },
    },
    methods: {
        submit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.isLoading = true;
                    this.$api({
                        url: '/LoginPage/ResetPassword',
                        method: 'post',
                        data: this.form,
                    }).then(() => {
                        this.isSetPassFinished = true;
                        this.isLoading = false;
                    });
                }
            });
        },
        login() {
            this.$router.push({ path: `/${this.form.cmp}/login` });
        },
        base64UrlDecode(input) {
            if (!input) return '';

            // 1. URL-safe → Base64
            let base64 = input.replace(/-/g, '+').replace(/_/g, '/');

            // 2. 補 padding
            const pad = base64.length % 4;
            if (pad) {
                base64 += '='.repeat(4 - pad);
            }

            // 3. Base64 decode
            const binary = atob(base64);

            // 4. 轉 Uint8Array
            const bytes = new Uint8Array(binary.length);
            for (let i = 0; i < binary.length; i += 1) {
                bytes[i] = binary.charCodeAt(i);
            }

            // 5. UTF-8 decode
            return new TextDecoder().decode(bytes);
        },
    },
};
</script>
